import React, { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { AboutBuisness } from "./about-business";
import { AboutExportStatus } from "./about-exportStatus";
import { AboutHistory } from "./about-history";
import { AboutOverView } from "./about-overview";
export interface Props {setData : Function}
export const About:React.FC<Props> = ({setData}) => {
    const location = useLocation()
    const path = location.pathname.split('/')
    useLayoutEffect(()=>{
        switch(path[2]){
            case 'overView' : setData((prev:any)=>({...prev, title_2_kr : '회사개요', title_2_en : 'Overvew', className_2 : 'company_overview'})); break;
            case 'history' : setData((prev:any)=>({...prev, title_2_kr : '연혁', title_2_en : 'History', className_2 : 'history'})); break;
            case 'exportStatus' : setData((prev:any)=>({...prev, title_2_kr : '수출현황', title_2_en : 'Export Status', className_2 : 'export_status'})); break;
            case 'business' : setData((prev:any)=>({...prev, title_2_kr : '사업장소개', title_2_en : 'Location', className_2 : 'businessSite_introduction'})); break;
        }
    }, [location])
    return(
        <>
        {path[2]==='overView' ? <AboutOverView/> : ''}
        {path[2]==='history' ? <AboutHistory/> : ''}
        {path[2]==='exportStatus' ? <AboutExportStatus/> : ''}
        {path[2]==='business' ? <AboutBuisness/> : ''}
        </>
    )
}